module.exports = __webpack_public_path__ + "static/media/mr.a3c31876.svg";